/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createTourOperatorAllotmentFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, type TourOperatorAllotment, type ValidationProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Allotment/GetForTourOperator/{id}
 */
export interface GetForTourOperatorItemRequestBuilder extends BaseRequestBuilder<GetForTourOperatorItemRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<TourOperatorAllotment>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<TourOperatorAllotment | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const GetForTourOperatorItemRequestBuilderUriTemplate = "{+baseurl}/Allotment/GetForTourOperator/{id}";
/**
 * Metadata for all the requests in the request builder.
 */
export const GetForTourOperatorItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: GetForTourOperatorItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createTourOperatorAllotmentFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
